import { useState, useEffect } from 'react';
import axiosInstance from '../../helpers/axios';
import calender from "../../assets/images/calender.png";
import { resolutionDpdData } from "./sampleData";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Datetime from 'react-datetime';
import moment from 'moment';
import { useSelector } from "react-redux";

export default function ResolutionDpd() {
  const [resolutionData, setResolutionData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [daywiseData, setDaywiseData] = useState([]);
  const [daywiseLoading, setDaywiseLoading] = useState(false);
  const [daywiseError, setDaywiseError] = useState(null);
  const [showDaywiseModal, setShowDaywiseModal] = useState(false);
  const [selectedBucket, setSelectedBucket] = useState(null);
  const productTypeSelected = useSelector((state) => state.ProductTypeFilter.selectedProductType);
  function formatNumberWithCommas(number) {
    return number?.toLocaleString('en-IN'); 
  }

  const handleRowClick = async (item) => {
    // Toggle off if same row is clicked again
    if (selectedBucket === item.bucket) {
      setSelectedBucket(null);
      setShowDaywiseModal(false);
      setDaywiseData([]);
      setDaywiseError(null);
      return;
    }

    setSelectedBucket(item.bucket);
    setShowDaywiseModal(true);
    setDaywiseLoading(true);
    setDaywiseError(null);
    try {
      const url = `/analytics/get-resolution-dpd-data-daywise`;
      const params = {};
      if (selectedDate) {
        params.date = moment(selectedDate).format('YYYY-MM-01');
      }
      if (item?.bucket) {
        params.dpdPeriod = item.bucket;
      }
      if (productTypeSelected && productTypeSelected !== "all") {
        params.loanType = Number(productTypeSelected);
      }
      const res = await axiosInstance.get(url, {
        params,
        headers: {
        },
      });
      setDaywiseData(res?.data?.data || []);
    } catch (err) {
      setDaywiseError(err?.message || 'Failed to load daywise data');
    } finally {
      setDaywiseLoading(false);
    }
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    const formatted = moment(date).format('YYYY-MM-01');
  }

  const handleClearDate = () => {
    setSelectedDate(null);
    setSelectedBucket(null);
    setShowDaywiseModal(false);
    setDaywiseData([]);
    setDaywiseError(null);
  }

  const calculateCumulativePercentages = (data) => {
  let cumulativeCount = 0;
  let cumulativeAmount = 0;
  
  return data.map((item, index) => {
    if (item.bucket === "Total") {
      return { ...item, cumulative_count_percentage: null, cumulative_amount_percentage: null };
    }
    
    if (item.bucket === "Unresolved") {
      return { ...item, cumulative_count_percentage: null, cumulative_amount_percentage: null };
    }
    
    cumulativeCount += parseFloat(item.count_percentage.replace('%', ''));
    cumulativeAmount += parseFloat(item.amount_percentage.replace('%', ''));
    
    return {
      ...item,
      cumulative_count_percentage: `(${cumulativeCount.toFixed(2)}%)`,
      cumulative_amount_percentage: `(${cumulativeAmount.toFixed(2)}%)`
    };
  });
 };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      setError(null)
      try {
        let queryParams = {}
        const url = `/analytics/get-resolution-dpd-data`
        if(selectedDate){
            const formattedDate = moment(selectedDate).format('YYYY-MM-01')
            queryParams.date = formattedDate
        }
        if (productTypeSelected && productTypeSelected !== "all") {
          queryParams.loanType = Number(productTypeSelected);
        }
        const res = await axiosInstance.get(url, {
            params: queryParams,
            headers: {
            },
        })
        const dataWithCumulative = calculateCumulativePercentages(res?.data?.data || []);
        setResolutionData(dataWithCumulative)
        // setResolutionData(resolutionDpdData?.data || [])
      } catch (err) {
        setError(err?.message || 'Failed to load')
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [selectedDate, productTypeSelected])

  return (
    
    <div style={{width:"100%",backgroundColor:'white',minHeight:'100vh'}}>
    <p style={{textAlign:"center",fontFamily:'Inter-Medium',color:'#667085',fontSize:'25px'}}>Resolution Tracking </p>
              <div style={{ height:'30px',borderRadius: '20px',marginLeft:'10px',marginBottom:'50px', display: 'flex', gap: '10px', alignItems: 'center' }}>
               <Datetime
                  value={selectedDate}
                  onChange={handleDateChange}
                  closeOnSelect={true}
                  dateFormat="MMMM YYYY"
                  timeFormat={false}
                  locale="en-gb"
                  isValidDate={(currentDate) => {
                    return currentDate.isSameOrBefore(moment(), "month");
                  }}
                  inputProps={{
                    placeholder: "Select Month",
                    style: {
                      height: "36px",
                      fontFamily: "Inter-Medium",
                      backgroundImage: `url(${calender})`,
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "5px center",
                      backgroundSize: "15px 15px",
                      paddingLeft: "30px",
                      fontSize: "14px",
                      color: "#000",
                      border: "1px solid #ccc",
                      borderRadius: "7px",
                      width: "100%",
                      marginTop: "2px",
                    },
                    value: selectedDate ? moment(selectedDate).format('MMMM YYYY') : '',
                  }}/>
                  {selectedDate && (
                <div style={{ flexShrink: 0 }}>
                    <button
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '130px',
                        backgroundColor: '#D22129',
                        height: '34px',
                        borderStyle: 'none',
                        borderRadius: "5px",
                        color: 'white',
                        fontFamily: "Inter-Medium",
                        paddingLeft: '10px',
                        whiteSpace: 'nowrap',
                        marginLeft:'30px'
                      }}
                      onClick={handleClearDate}
                    >
                     Clear Filter
                    </button>
                  </div>
              )}
              </div>
              
         {loading ? (
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '15%' }}>
                <CircularProgress />
            </Box>
         ):(
            <>
            <table className='tables' style={{margin:'10px',padding:'10px',width:"95%"}}>
          <thead className='table-heading'>
            <tr>
              <th style={{ fontSize: '14px', fontFamily: "Inter-Medium", paddingLeft: '10px' }}>Buckets</th>
              <th style={{ fontSize: '14px', fontFamily: "Inter-Medium" }}>Bounced EMIs</th>
              <th style={{ fontSize: '14px', fontFamily: "Inter-Medium" }}>Count %</th>
              <th style={{ fontSize: '14px', fontFamily: "Inter-Medium" }}>Bounced Amount</th>
              <th style={{ fontSize: '14px', fontFamily: "Inter-Medium" }}>Recovered Amount</th>
              <th style={{ fontSize: '14px', fontFamily: "Inter-Medium" }}>Amount %</th>
            </tr>
          </thead>
          
          <tbody className='table-body'>
            {error ? (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center', padding: '20px', color: 'red' }}>{error}</td>
              </tr>
            ) : (
              resolutionData.map((item, index) => {
                const isLast = index === resolutionData.length - 1;
                return (
                  <tr key={index} onClick={!isLast ? () => handleRowClick(item) : undefined} style={{lineHeight:"25px", backgroundColor: isLast ? '#F3F4F6' : (selectedBucket === item.bucket ? '#E6F2FF' : (index % 2 === 0 ? '#F9FAFB' : 'white')), cursor: isLast ? 'default' : 'pointer' }}>
                  <td style={{ fontSize: '14px', cursor: isLast ? 'default' : 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.bucket}</td>
                  <td style={{ fontSize: '14px', cursor: isLast ? 'default' : 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{formatNumberWithCommas(item.bounced_emis)}</td>
                  <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>
                    <span style={{ display: 'inline-block', width: '60px' }}>{item.count_percentage}</span>
                    {item.cumulative_count_percentage && (
                      <span style={{color:'black', marginLeft:'10px'}}>
                        {item.cumulative_count_percentage}
                      </span>
                    )}
                  </td>              
                  <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{formatNumberWithCommas(parseFloat(item.bounced_amount.replace(/,/g, '')))}</td>
                  <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{formatNumberWithCommas(parseFloat(item.recovered_amount.replace(/,/g, '')))}</td>
                  <td style={{ fontSize: '14px', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>
                    <span style={{ display: 'inline-block', width: '60px' }}>{item.amount_percentage}</span>
                    {item.cumulative_amount_percentage && (
                      <span style={{color:'black', marginLeft:'10px'}}>
                        {item.cumulative_amount_percentage}
                      </span>
                    )}
                  </td>                
                  </tr>
              );
            })
            )}
           
          </tbody>
        </table>

        {showDaywiseModal && (
          <div style={{marginTop:'20px', width:'95%', marginLeft:'10px'}}>
            <div style={{display:'flex', justifyContent:'center', alignItems:'center', marginBottom:'10px'}}>
              <p style={{textAlign:"center",fontFamily:'Inter-Medium',color:'#667085',fontSize:'25px'}}>Resolution details for {selectedBucket}{selectedDate ? ' - ' + moment(selectedDate).format('MMMM YYYY') : ''}</p>
            </div>

            {daywiseLoading ? (
              <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
                <CircularProgress />
              </Box>
            ) : daywiseError ? (
              <div style={{color:'red'}}>{daywiseError}</div>
            ) : daywiseData && daywiseData.length > 0 ? (
              <table className='tables' style={{padding:'10px',width:"100%"}}>
                <thead className='table-heading'>
                  <tr>
                    <th style={{fontFamily:'Inter-Medium', fontSize:'14px'}}>Loan ID</th>
                    <th style={{fontFamily:'Inter-Medium', fontSize:'14px'}}>Due Date</th>
                    <th style={{fontFamily:'Inter-Medium', fontSize:'14px'}}>EMI Amount</th>
                    <th style={{fontFamily:'Inter-Medium', fontSize:'14px'}}>Amount Paid</th>
                    <th style={{fontFamily:'Inter-Medium', fontSize:'14px'}}>Amount Paid Date</th>
                    {/* <th style={{fontFamily:'Inter-Medium', fontSize:'14px'}}>Status</th> */}
                  </tr>
                </thead>
                <tbody className='table-body'>
                  {daywiseData.map((row, idx) => (
                    <tr key={idx} style={{backgroundColor: idx % 2 === 0 ? '#F9FAFB' : 'white',lineHeight:"25px"}}>
                      <td style={{fontSize: '14px',padding:'8px', fontFamily:'Inter-Medium',color: '#667085'}}>{row.legacy_loan_id}</td>
                      <td style={{fontSize: '14px',padding:'8px', fontFamily:'Inter-Medium',color: '#667085'}}>{row.due_date ? moment(row.due_date).format('DD MMM YYYY') : row.dueDate ? moment(row.dueDate).format('DD MMM YYYY') : '-'}</td>
                      <td style={{fontSize: '14px',padding:'8px', fontFamily:'Inter-Medium',color: '#667085'}}>{(row.emi_amount ) ? formatNumberWithCommas(parseFloat(String(row.emi_amount).replace(/,/g, ''))) : '-'}</td>
                      <td style={{fontSize: '14px',padding:'8px', fontFamily:'Inter-Medium',color: '#667085'}}>{(row.repaid_emi_amount) ? formatNumberWithCommas(parseFloat(String(row.repaid_emi_amount).replace(/,/g, ''))) : '-'}</td>
                      <td style={{fontSize: '14px',padding:'8px', fontFamily:'Inter-Medium',color: '#667085'}}>{row.emi_repaid_date ? moment(row.emi_repaid_date).format('DD MMM YYYY') : '-'}</td>
                      {/* <td style={{fontSize: '14px',padding:'8px', fontFamily:'Inter-Medium',color: '#667085'}}>{row.status == 4 ? 'OverduePaid': row.status==5?"Overdue":"-"}</td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div>No data available</div>
            )}

          </div>
        )}

            </>
         )}

</div>
  )
}
